// extracted by mini-css-extract-plugin
export default {"exchanges":"Resources_exchanges__TvVrW","heading":"Resources_heading__-iceB"};